import { FC } from "react";
import ServicePage from "./ServicePage";

const FireServicePage: FC = () => (
  <ServicePage
    title="İtfaiye Hizmeti"
    seoDescription="Yangına ilk müdahalede bulunan uzman Acil Müdahale Timi (AMT) ile şehir itfaiyesi gelene kadar geçen sürede oluşabilecek kayıpları önleyen Securitas İtfaiye Hizmeti."
    intro={[
      "Yangında en büyük sıcaklık artışı ilk 5 dakikada yaşanır ve hayati öneme sahiptir. Yangın algılandıktan sonra en kısa zamanda tespit ve müdahale gerçekleştirilirse yangın önlenebilir. İlk müdahale ancak olay yerinde bulunan itfaiye ekibi ile mümkündür. Yangına ilk müdahalede bulunan uzman bir Acil Müdahale Timi'ni (AMT) işletmeler ile buluşturan Securitas İtfaiye Hizmetleri, şehir itfaiyesi olay yerine gelene kadar geçen sürede ortaya çıkabilecek kayıpları, geri dönüşü olmayan boyutlara ulaşmadan önce önleyebilir.",
    ]}
    sections={[
      {
        icon: "grad",
        title: "Eğitim",
        paragraphs: [
          <>
            Tesislerde yangın risk durumuna göre, ilk müdahale ekiplerine yasaların
            öngördüğü temel itfaiyecilik eğitiminin yanı sıra tesis içi eğitimler de
            verilir. Bu eğitimler, belirlenen <b>yangın risk değeri</b> içinde yılda
            bir, iki yılda bir ya da üç yılda bir tekrarlanacağı gibi altı ayda bir
            oryantasyon eğitimleri şeklinde de yapılabilir.
          </>,
          "Tamamı sertifikalı olan eğitimlerimizi başarıyla tamamlamış Acil Müdahale Timi'nde yer alan uzmanlarımız; yıl içinde de birçok tatbikata katılır ve uzmanlıklarını güncel bilgilerle destekler.",
        ],
      },
    ]}
    image={{
      src: "/uploads/site/itfaiye-araci.jpg",
      alt: "Securitas İtfaiyesi aracı",
    }}
  />
);

export default FireServicePage;
